import React, { Component } from 'react';
import { Input, } from 'reactstrap';

export class FileUpload extends Component {
    constructor(props) {
        super(props);
        this.handleChangeFile = this.handleChangeFile.bind(this);

        this.inputRef = null;
        this.setInputRef = (element) => {
            this.inputRef = element;
        };
    }

    handleChangeFile(e) {
        e.preventDefault();
        // TOOD: Input validation

        let file = this.inputRef.files[0];
        // resets the original value so if we 
        // reselect the same file this method will fire
        this.inputRef.value = '';
        if (file.size > 5120000) {
            window.alert('file is too large');
            return;
        }
        if (!this.props.accept.includes(file.type)) {
            window.alert('file is not supported');
            return;
        }
        console.log(file);
        return this.props.handleChangeFile(file);
    }

    render() {
      return (
          <div className="btn btn-primary k-upload-button margin-top-10">
          <Input
                name="fileUploadInput"
                onChange={this.handleChangeFile}
                type="file"
                accept={this.props.accept}
                  innerRef={this.setInputRef}
                  alt="Button to select a new avatar"
          />
          <span>Select Profile Picture</span>
        </div>
            
        );
    }
}